import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NavItem } from './nav-item';
import { Router } from '@angular/router';
import { VendorService } from 'src/app/_services/vendor.services';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { Role } from 'src/app/util/enums/role.enum';
import { MatMenu } from '@angular/material/menu';

@Component({
  selector: 'telio-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss']
})
export class MenuItemComponent implements OnInit {
  adminrole: any;
  userDetails: any = {};
  @Input() items: NavItem[];
  @ViewChild('childMenu', { static: true }) public childMenu: MatMenu;

  constructor(private router: Router,  private userInfoService: UserInfoService, private vendorservice: VendorService,) { }
  
  ngOnInit(): void {
    this.userDetails = this.userInfoService.userDetails;
    this.adminrole = this.userInfoService.isAdminGroup() ;
  }

  isActive(item) {
    return item.children.findIndex(x => x.route == this.router.url) > -1;
  }
}
